import { foundationSelectEditor, foundationNumberEditor, foundationMultiselectEditor, foundationDateEditor, foundationStringEditor, } from './cell-editors';
import { foundationGridProActionRenderer, foundationGridProActionsMenuRenderer, foundationAgBooleanRenderer, foundationAgEditableRenderer, foundationAgSelectRenderer, foundationAgTextRenderer, foundationAgTextFieldRenderer, } from './cell-renderers';
import { foundationGridPro } from './grid-pro';
/**
 * The Grid Pro Components.
 * @remarks Contains all available components, from Grid Pro itself to the cell renderers.
 * @public
 */
export const foundationGridComponents = {
    foundationGridProActionRenderer,
    foundationGridProActionsMenuRenderer,
    foundationAgBooleanRenderer,
    foundationAgTextRenderer,
    foundationAgTextFieldRenderer,
    foundationAgEditableRenderer,
    foundationAgSelectRenderer,
    foundationGridPro,
    foundationSelectEditor,
    foundationNumberEditor,
    foundationDateEditor,
    foundationMultiselectEditor,
    foundationStringEditor,
    register(container, ...rest) {
        if (!container) {
            // preserve backward compatibility with code that loops through
            // the values of this object and calls them as funcs with no args
            return;
        }
        for (const key in this) {
            if (key === 'register') {
                continue;
            }
            this[key]().register(container, ...rest);
        }
    },
};
